import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DiscountCouponsService {

  constructor(private http: HttpClient) { }

  addDiscountCoupon(data) {
    return this.http.post(`${environment.apiUrl}coupon`, data);
  }

  updateDiscountCoupon(id, data) {
    return this.http.put(`${environment.apiUrl}coupon/${id}`, data);
  }

  getDiscountCouponById(id:string) {
    return this.http.get(`${environment.apiUrl}coupon/${id}`);
  }

  getAllDiscountCoupons(query:string) {
    return this.http.get(`${environment.apiUrl}coupon${query}`);
  }
}
